import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.invitedentity').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function routesConfig($stateProvider) {
        $stateProvider
            .state('app.invitedentity', {
                abstract: true,
                component: 'contentLayout',
            })
            .state('app.invitedentity.list', {
                url: '/invitedentity/list',
                views: {
                    content: {
                        component: 'listKissInvitedEntitys',
                    },
                },
                resolve: {
                    keepSearchData: keepSearchData,
                },
            })
            .state('app.invitedentity.edit', {
                url: '/invitedentity/:id/edit',
                resolve: {
                    invitedEntityBo: getInvitedEntity,
                },
                views: {
                    content: {
                        component: 'editInvitedEntity',
                    },
                },
                params: {
                    id: null,
                    type: null,
                },
            })
            .state('app.invitedentity.sellerrelations', {
                url: '/invitedentity/:id/seller-relations',
                resolve: {
                    sellerBo: getSeller,
                    relations: getSellerRelations,
                },
                views: {
                    content: {
                        component: 'listKissSellerRelations',
                    },
                },
            })
            .state('app.invitedentity.buyerrelations', {
                url: '/invitedentity/:id/buyer-relations',
                resolve: {
                    invBuyerBo: getInvitedEntity,
                    relations: getInvBuyerRelations,
                },
                views: {
                    content: {
                        component: 'invBuyerRelations',
                    },
                },
            })
            .state('app.invitedentity.details_subentities',{
                url: '/invited_details_subentities/:subEntityId',
                views: {
                    content: {
                        component: 'invitedDetailsSubEntities'
                    },
                },
                resolve: {
                    subEntity: getSubEntity,
                    countries: getCountries,
                },
                params: {
                    invitedEntityId: null,

                },
            })
        getCountries.$inject = ['CountrySvc'];
        function getCountries(CountrySvc) {
            return CountrySvc.getAll();
        }

        getSubEntity.$inject = ['$transition$', 'PrincipalSvc'];
        function getSubEntity($transition$, PrincipalSvc) {
            return PrincipalSvc.getSubEntity($transition$.params().subEntityId);
        }

        getInvitedEntityBuyer.$inject=['$transition$', 'invitedEntitySvc']
        function getInvitedEntityBuyer($transition$, invitedEntitySvc) {
            return invitedEntitySvc.getInvitedEntityBuyer($transition$.params().id);
        }
        getInvitedEntity.$inject = ['$transition$', 'invitedEntitySvc'];
        function getInvitedEntity($transition$, invitedEntitySvc) {
            if ($transition$.params().type === 'SELLER') {
                return invitedEntitySvc.getInvitedEntitySeller($transition$.params().id);
            } else {
                return invitedEntitySvc.getInvitedEntityBuyer($transition$.params().id);
            }
        }

        getSeller.$inject = ['$transition$', 'KissSellerSvc'];
        function getSeller($transition$, KissSellerSvc) {
            return KissSellerSvc.getSeller($transition$.params().id);
        }

        getSellerRelations.$inject = ['sellerBo', 'SellerRelationFilter', 'KissSellerSvc'];
        function getSellerRelations(sellerBo, SellerRelationFilter, KissSellerSvc) {
            return KissSellerSvc.searchRelations(sellerBo.seller.legalEntity.id, new SellerRelationFilter());
        }

        keepSearchData.$inject = ['$transition$'];
        function keepSearchData($transition$) {
            return (
                $transition$.from().name === 'app.invitedentity.edit' ||
                $transition$.from().name === 'app.invitedentity.sellerrelations' ||
                $transition$.from().name === 'app.invitedentity.buyerrelations'
            );
        }

        getInvBuyerRelations.$inject = ['PrincipalSvc', 'invBuyerBo', 'InvBuyerRelationFilter', 'invitedEntitySvc'];
        function getInvBuyerRelations(PrincipalSvc, invBuyerBo, InvBuyerRelationFilter, invitedEntitySvc) {
            var filter = new InvBuyerRelationFilter();
            return invitedEntitySvc.searchInvBuyerRelations(invBuyerBo.invitedEntity.legalEntity.id, filter);
        }
    }
})();
